<template lang="pug">

</template>

<script>

export default {
  name: 'Dispatch',
  props: {    
  },
  components:{
    
  },
  metaInfo: {
    title: 'Dispatch',
  },
  data:function(){
    return{
      gandalf:false,
      
    }
  },
  methods:{
    platformFail(){      
      if(this.gandalf) this.$router.push({path:'/dashboard/wizard/2'})
      else this.$router.push({path:'/dashboard/connectPlatforms'})
    },
    platformPass(){
      if(this.gandalf) this.$router.push({path:'/dashboard/wizard/3'})
      else this.$router.push({path:'/dashboard/connectPlatforms'})
    },
    async shopifyHandler(){    
      if( this.$route.query.success == 'true'){ 
        this.flash('Shopify Store Added', 'success')
        let createWidget = await this.axios.post(`/widgetmanager/create`,{key:this.$route.query.widget})
        if (createWidget.data.success == true) {
          this.flash('Widget Created', 'success');
        }else{
          this.flash('Something went wrong with widget creation.', 'error');
        }
        this.platformPass()
      }else if(this.$route.query.success == 'false'){
        if(this.$route.query.error == 'duplicate_store') this.flash('There was a Duplicate Shopify Store','warning', {timeout:10000})
        if(this.$route.query.error == 'access_denied') this.flash('Access Denied','warning',{timeout:10000})
        if(this.$route.query.error == 'channel_creation_failed') this.flash('Platform Creation Failed','warning',{timeout:10000})          
        this.platformFail()
      }
    },
  },
  async mounted(){
    if (localStorage.getItem('gandalf')) this.gandalf = JSON.parse(localStorage.getItem('gandalf'));
    if(this.$route.query.platform == 'shopify') this.shopifyHandler()
    
    
  },
  async created(){    
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  
</style>
